import { useQuery } from '@tanstack/react-query'

import { ClientContractsService } from '../services/client_contracts.service'
import { APIContractClientDtoResponse } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientServiceAgreementContract = (
  locationName: string,
  options: { hasSharedCRM: boolean | null; enabled?: boolean }
) => {
  const { hasSharedCRM, enabled = true } = options

  return useQuery<APIContractClientDtoResponse | null>({
    queryKey: ['clientServiceAgreementContract', locationName, hasSharedCRM],
    queryFn: () => ClientContractsService.listServiceAgreements(locationName, { hasSharedCRM: !!hasSharedCRM }),
    ...defaultQueryOptions,
    enabled: !!locationName && enabled && hasSharedCRM !== null,
  })
}
